import React from 'react'

import reservaImg from 'url:../assets/projects/reserva-ya.jpg'
import elcImg from 'url:../assets/projects/mac-cosmetics.jpg'
import cnelImg from 'url:../assets/projects/cnel.jpg'
import sngrImg from 'url:../assets/projects/sngr.jpg'
import notifyImg from 'url:../assets/projects/notify-goit.jpg'
import doxiImg from 'url:../assets/projects/doxi.jpg'
import doxiCafeImg from 'url:../assets/projects/doxi-cafe.jpg'

const covers = {
  reserva: [reservaImg],
  elc: [elcImg],
  cnel: [cnelImg],
  sngr: [sngrImg],
  notify: [notifyImg],
  doxi: [doxiImg, doxiCafeImg]
}

function ProjectLink({ href, label }) {
  return (
    <a
      className="project-link"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
    >
      <span>{label}</span>
      <b>↗</b>
    </a>
  )
}

export default function Projects({ projects, lang, t }) {
  return (
    <section className="section" id="projects">
      <div className="container">
        <div className="section-head">
          <div>
            <p className="eyebrow">{t.featured}</p>
            <p>{t.featuredSub}</p>
          </div>
        </div>

        <div className="project-grid">
          {projects.map((p) => (
            <article className="project" key={p.id}>
              <div className="project-cover">
                {covers[p.id].map((src) => (
                  <img key={src} src={src} alt={p.title} loading="lazy" />
                ))}
                <span className="cover-tag">{p.category[lang]}</span>
              </div>

              <div className="project-info">
                <h3>{p.title}</h3>

                <p>{p.description[lang]}</p>

                <small className="project-stack">{p.stack}</small>

                {p.links ? (
                  <div className="project-links">
                    {p.links.map((l) => (
                      <ProjectLink key={l.url} href={l.url} label={l.label} />
                    ))}
                  </div>
                ) : (
                  <ProjectLink href={p.url} label={t.viewProject} />
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}
